export const TYPING_EVENT = 'TYPING_EVENT';
export const TYPING_EVENT_STOP = 'TYPING_EVENT_STOP';
